angular.module('galilai.creator').controller('TrialController', function($scope, $timeout, $rootScope, $http, $location, api, experiments) {
    const featuresMap = _trans.trial.features
    $scope.plans = {
        'pt': {
            'monthly': {
                'id' : 'monthly',
                'period': 'mês',
                'price': '27,90',
                'currency': 'R$',
            },
            'yearly': {
                'id' : 'yearly',
                'period': 'ano',
                'price': '179,90',
                'currency': 'R$',
                'discount': 47
            },
        },
        'en': {
            'monthly': {
                'id' : 'monthly',
                'period': 'month',
                'price': '9.80',
                'currency': '$',
            },
            'yearly': {
                'id' : 'yearly',
                'period': 'year',
                'price': '79.90',
                'currency': '$',
                'discount': 33,
            }
        },
        'es': {
            'monthly': {
                'id' : 'monthly',
                'period': 'mes',
                'price': '9.80',
                'currency': '€',
            },
            'yearly': {
                'id' : 'yearly',
                'period': 'año',
                'price': '79.90',
                'currency': '$',
                'discount': 33,
            }
        },
        'it': {
            'monthly': {
                'id' : 'monthly',
                'period': 'mese',
                'price': '9.80',
                'currency': '€',
            },
            'yearly': {
                'id' : 'yearly',
                'period': 'anno',
                'price': '79.90',
                'currency': '$',
                'discount': 33,
            }
        },
        'fr': {
            'monthly': {
                'id' : 'monthly',
                'period': 'mois',
                'price': '9.80',
                'currency': '€',
            },
            'yearly': {
                'id' : 'yearly',
                'period': 'an',
                'price': '79.90',
                'currency': '$',
                'discount': 33,
            }
        },
        'de': {
            'monthly': {
                'id' : 'monthly',
                'period': 'Monat',
                'price': '9.80',
                'currency': '€',
            },
            'yearly': {
                'id' : 'yearly',
                'period': 'Jahr',
                'price': '79.90',
                'currency': '$',
                'discount': 33,
            }
        },
    }[language || 'en']

    $scope.features = featuresMap[language || 'en']
    $scope.email = null
    $scope.extraMessage = null

    $scope.loading = false
    $rootScope.$on('trialSource', function(event, source) {
        let key = 'source.' + source
        let value = gettext(key);
        if (value !== key) {
            $scope.extraMessage = value
        } else {
            $scope.extraMessage = null
        }
    })

    $rootScope.$on('updatedUserInfo', function(event, args) {
        $timeout(() => {
            let email = localStorage.getItem('auth.user.email')
            if (email) {
                $scope.email = email
            }
        })
    })

    $rootScope.$on('onUserData', function(event, data) {
        $timeout(() => {
            if (data.user && data.user.email) {
                $scope.email = data.user.email
            }
        })
    })

    // Listen for onGoogleAuth
    window.addEventListener('message', function(event) {
        if (event.data.type === 'onGoogleAuth' && event.data.source === 'trial') {
            $timeout(() => {
                $scope.credentials = event.data.credentials
                if (event.data.decoded && event.data.decoded.email) {
                    $scope.email = event.data.decoded.email
                }

                $scope.startTrial()
            })
        }
    })

    $scope.startTrial = function(planPeriod) {
        try {
            track('Editor Trial Click')
        } catch (e) {
            console.log(e)
        }
        if ((!$scope.email || $scope.email.length < 3) && (!$scope.credentials)) {
            showError(gettext('error.validation.email'))
            return
        }
        // Update email
        if (!$scope.credentials) {
            try {
                improvedEmail = fixCommonEmailTypos($scope.email);
                if (improvedEmail) {
                    $scope.email = improvedEmail;
                }
                console.log($scope.email, improvedEmail);
            } catch (e) {
                console.log(e)
            }
        }
        try {
            identifyUserData($scope.email)
        } catch (e) {}
        let inputForm = getUserLoginForm($scope.email)
        inputForm.meta.google = $scope.credentials

        $scope.loading = true
        let trialInput = {
            form: inputForm,
            type: $rootScope.trialMode || 'initial',
            cancelURL: $location.absUrl(),
            coupon: inputForm.meta.coupon,
            tempId: $rootScope.userTempID,
        }
        if (experiments.isVariant('start-trial-pro')) {
            trialInput.planId = 'premium'
        } else if (experiments.isVariant('start-trial-max')) {
            trialInput.planId = 'max'
        }
        if (planPeriod) {
            trialInput.plan = planPeriod
        }
        api.startTrial(trialInput).then(function(response) {
            let data = response.data
            try {
                if (data && data.user && data.user._id) {
                    identifyUserWithId(data.user._id)
                }
            } catch (e) {}
            if (data && data.already_customer) {
                if (data.token) {
                    console.log('[Customer]', data)
                    localStorage.setItem('auth.token', data.token)
                    reloadLocation(true)
                    return
                }
                $scope.loading = false
                $rootScope.hideTrial()
                showLoginModal(function() {
                    reloadLocation(true)
                }, true, {
                    email: $scope.email
                }, autoSubmit=true)
                return
            }
            // If started trial without asking for payment
            if (data && data.trial_started) {
                if (data.token) {
                    localStorage.setItem('auth.token', data.token)
                    showSuccess(gettext('success.trial_started'), null, function() {
                        reloadLocation(true)
                    })
                    track('Editor Trial Started Without Payment')
                    return
                } else {
                    showError(gettext('error.starting_trial'))
                    return
                }
            }

            try {
                // Track trial start open
                track('Editor Trial Open')

                // Trial Signup
                if (!isLoggedIn()) {
                    track('Editor Signup')
                }
                gtag('set', 'user_data', {
                    "email": $scope.email
                });
            } catch (e) {
                console.log(e)
            }
            $timeout(() => {
                if (data.url) {
                    $rootScope.startCheckout(data)
                }
                $scope.loading = false
            }, 200)
        }).catch(function(err) {
            $scope.loading = false
            console.log(err)
        })

        function getUserConfig() {
            api.config({}).then(function(res) {
                $rootScope.userConfig = res.data
                $rootScope.hideTrial()
            })
            .catch(function() {
                // TASK - No handling
            })
        }
        let interval = setInterval(() => {
            // Monitor local storage trial.started
            if (localStorage.getItem('trial.started')) {
                clearInterval(interval)
                getUserConfig();
                // Remove local storage trial.started
                localStorage.removeItem('trial.started')
                track('Editor Trial Started')
            }
        }, 500)
    }

    $scope.handleKeyPressEmail = function($evt) {
        if ($evt.keyCode === 13) {
            $scope.startTrial()
        }
    }
})
